import { state } from '../core/state.js';

export function toggleSearch() {
    const panel = document.getElementById('search-panel');
    const btn   = document.getElementById('btn-search');
    if (!panel) return;
    const open = panel.classList.toggle('is-open');
    if (btn) btn.classList.toggle('search-active', open);
    if (open) {
        document.getElementById('search-kw')?.focus();
    } else {
        resetSearch();
    }
}

export function fermerRecherche() {
    const panel = document.getElementById('search-panel');
    const btn   = document.getElementById('btn-search');
    if (panel) panel.classList.remove('is-open');
    if (btn)   btn.classList.remove('search-active');
    resetSearch();
    if (typeof window.fermerResultats === 'function') window.fermerResultats();
}

export function resetSearch() {
    const kw     = document.getElementById('search-kw');
    const author = document.getElementById('search-author');
    if (kw)      kw.value = '';
    if (author)  author.value = '';
    document.querySelectorAll('.search-chip.active').forEach(c => c.classList.remove('active'));
}

export function toggleSearchType(btn) {
    if (!btn) return;
    const wasActive = btn.classList.contains('active');
    document.querySelectorAll('.search-chip').forEach(c => c.classList.remove('active'));
    if (!wasActive) btn.classList.add('active');
}

export async function lancerRecherche() {
    const query  = (document.getElementById('search-kw')?.value || '').trim();
    const auteur = (document.getElementById('search-author')?.value || '').trim().toLowerCase();
    const chip   = document.querySelector('.search-chip.active');
    const type   = chip ? chip.dataset.type : null;

    if (!query && !auteur && !type) return;

    // Si on est en MP chiffré : recherche hybride IndexedDB + DOM
    if (state.destinataireID && window.ChaosKeystore) {
        try {
            const msgsIDB = await window.ChaosKeystore.searchMessages(state.destinataireID, query ? query.toLowerCase() : null);
            const resultatsIDB = msgsIDB
                .filter(m => !auteur || (m.auteur || '').toLowerCase().includes(auteur))
                .map(m => ({
                    li: null,
                    auteurTexte: m.auteur || '',
                    couleur: 'var(--theme-primary)',
                    heureTexte: new Date(m.date_envoi).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    extrait: (m.texte || '').slice(0, 120),
                    query
                }));

            const idsIDB = new Set(msgsIDB.map(m => String(m.id)));
            const resultatsDOM = [];
            
            document.querySelectorAll('#messages > li.message-item').forEach(li => {
                if (idsIDB.has(li.dataset.msgId)) return;
                let match = true;
                if (query) {
                    const texte = (li.querySelector('.message-content')?.textContent || '').toLowerCase();
                    if (!texte.includes(query.toLowerCase())) match = false;
                }
                if (auteur && match) {
                    const auteurMsg = (li.querySelector('.message-author')?.textContent || '').toLowerCase();
                    if (!auteurMsg.includes(auteur)) match = false;
                }
                if (type && match) {
                    if (type === 'gif')  match = !!li.querySelector('img.message-gif');
                    if (type === 'lien') match = !!li.querySelector('.message-content a');
                }
                if (match) {
                    const auteurEl  = li.querySelector('.message-author');
                    const timeEl    = li.querySelector('.message-time');
                    const contentEl = li.querySelector('.message-content');
                    const brut = contentEl?.textContent.trim() || '';
                    let extrait = brut.slice(0, 120) + (brut.length > 120 ? '...' : '');
                    if (query) {
                        const idx = brut.toLowerCase().indexOf(query.toLowerCase());
                        const debut = Math.max(0, idx - 40);
                        const fin   = Math.min(brut.length, idx + query.length + 60);
                        extrait = (debut > 0 ? '...' : '') + brut.slice(debut, fin) + (fin < brut.length ? '...' : '');
                    }
                    resultatsDOM.push({ 
                        li, 
                        auteurTexte: auteurEl?.textContent || '', 
                        couleur: auteurEl?.style.color || 'var(--theme-primary)', 
                        heureTexte: timeEl?.textContent || '', 
                        extrait, 
                        query 
                    });
                }
            });

            if (typeof window.afficherResultats === 'function') {
                window.afficherResultats([...resultatsIDB, ...resultatsDOM], query, auteur, type);
            }
            return;
        } catch (e) {
            console.warn('[E2EE] Recherche MP échouée, fallback DOM classique :', e.message);
        }
    }

    // Recherche standard plein texte dans le DOM (Salons publics ou fallback)
    const resultats = [];
    document.querySelectorAll('#messages > li.message-item').forEach(li => {
        let match = true;

        if (query) {
            const texte = (li.querySelector('.message-content')?.textContent || '').toLowerCase();
            if (!texte.includes(query.toLowerCase())) match = false;
        }
        if (auteur && match) {
            const auteurMsg = (li.querySelector('.message-author')?.textContent || '').toLowerCase();
            if (!auteurMsg.includes(auteur)) match = false;
        }
        if (type && match) {
            if (type === 'gif')  match = !!li.querySelector('img.message-gif');
            if (type === 'lien') match = !!li.querySelector('.message-content a');
        }

        if (match) {
            const auteurEl  = li.querySelector('.message-author');
            const timeEl    = li.querySelector('.message-time');
            const contentEl = li.querySelector('.message-content');
            const gifEl     = li.querySelector('img.message-gif');

            const auteurTexte = auteurEl?.textContent || '';
            const couleur     = auteurEl?.style.color || 'var(--theme-primary)';
            const heureTexte  = timeEl?.textContent || '';

            let extrait = '';
            if (gifEl) {
                extrait = '🖼️ GIF';
            } else if (contentEl) {
                const brut = contentEl.textContent.trim();
                if (query) {
                    const idx = brut.toLowerCase().indexOf(query.toLowerCase());
                    const debut = Math.max(0, idx - 40);
                    const fin   = Math.min(brut.length, idx + query.length + 60);
                    extrait = (debut > 0 ? '...' : '') + brut.slice(debut, fin) + (fin < brut.length ? '...' : '');
                } else {
                    extrait = brut.slice(0, 120) + (brut.length > 120 ? '...' : '');
                }
            }

            resultats.push({ li, auteurTexte, couleur, heureTexte, extrait, query });
        }
    });

    if (typeof window.afficherResultats === 'function') {
        window.afficherResultats(resultats, query, auteur, type);
    }
}